<template>
  <div>
    <baseFrame
      save-text=""
      clear-text=""
      submit-text="提交"
      :submit-loading="submitLoading"
      @submit="submitConfirm"
      @cancel="handleToList">
      <div slot="content">
        <lk-card title="基础商品信息">
          <lk-form
            ref="form"
            label-position="right"
            :label-width="134">
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="重复商品:">
                  <lk-button type="primary" @click="handleAdd">新增</lk-button>
                  <span>（增加后请选择一个商品作为合并至的商品）</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="">
                  <div>
                    <lk-table
                      ref="table"
                      border
                      highlight-row
                      :columns="columns"
                      :data="tableData"
                      @on-row-click="handleSelectClick"
                      @on-current-change="handleSelectGoods">
                    </lk-table>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="合并至:">
                  <span class="red">将重复商品与所选商品合并，疑似重复商品的所有业务单据均关联至所选商品</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="">
                  <div>
                    <lk-table border :columns="finalColumns" :data="finalTableData"></lk-table>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <DTPModal
      v-model="submitConfirmVisiable"
      content="合并商品后，重复商品的所有业务单据均关联合并至商品，确认提交？"
      :confirmLoading="submitLoading"
      @confirm="submit"
      @handleCancel="submitConfirmVisiable = false">
    </DTPModal>
    <lk-modal
      v-model="modalVisiable"
      :mask-closable="false"
      title="选择商品"
      width="900">
      <div class="queryContainer">
        <div class="queryItem">
          <goodsSearchItem v-model="modalQuery.nameMix" placeholder='支持商品编码、通用名、商品名'></goodsSearchItem>
        </div>
        <div class="queryItem">
          <lk-button type="primary" class="mr8" @click="handleModalSearch">查询</lk-button>
          <lk-button @click="clearModalQuery" class="mr8">重置</lk-button>
        </div>
      </div>
      <div style="position: relative;">
        <LoadingSpan v-show="modalLoading"></LoadingSpan>
        <lk-table
          border
          height="400"
          :columns="modalColumns"
          :data="modalTableData"
          @on-select="handleTempSelect"
          @on-select-cancel="handleTempCancel"
          @on-select-all="handleSelectAll"
          @on-select-all-cancel="handleSelectAllCancel">
        </lk-table>
      </div>
      <div style="margin-top: 14px; text-align: right;">
        <lk-page
          :total="modalPage.count"
          :page-size="modalPage.size"
          :current="modalPage.page"
          size="small"
          show-sizer
          show-total
          show-elevator
          @on-change="handleModalPage"
          @on-page-size-change="handleModalSize">
        </lk-page>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <span style="padding-right: 16px;">已选:{{this.tempSelection.length + this.tableData.length}}项</span>
          <lk-button @click="hideModal">取消</lk-button>
          <lk-button type="primary" class="mr" @click="pushModalData">确定</lk-button>
        </div>
      </div>
    </lk-modal>
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import toolsService from '../../services/tools';
import goodsService from '../../services/goods';
import utils from '../../libs/utils';
import DTPModal from '../../components/DTPModal';
import LoadingSpan from '../../components/LoadingSpan.vue';

export default {
  name: 'mergeEqualGoodsAdd',
  components: {
    baseFrame,
    DTPModal,
    LoadingSpan,
  },
  data() {
    return {
      submitConfirmVisiable: false,
      submitLoading: false,
      tableData: [],
      currentSelectedId: null, // 当前选中的合并至商品
      finalColumns: [],
      finalTableData: [],
      columns: [
        {
          title: '选择',
          key: 'id',
          width: 60,
          render: (h, { row }) => {
            const vm = this;
            return h('lk-radio', {
              props: {
                value: row.id === this.currentSelectedId,
              },
              on: {
                'on-change': (value) => {
                  if (!value) {
                    this.currentSelectedId = null;
                    vm.$refs.table.clearCurrentRow();
                  }
                },
              },
            });
          },
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        {
          title: '商品通用名',
          key: 'approvedDrugNames',
          minWidth: 130,
        },
        {
          title: '商品类型',
          key: 'typeString',
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'specifications',
          minWidth: 116,
        },
        {
          title: '批准文号/注册证号',
          key: 'approvalNumber',
          minWidth: 260,
        },
        {
          title: '单位',
          key: 'drugMiniPackageUnitString',
          minWidth: 116,
        },
        {
          title: '剂型',
          key: 'dosageFormString',
          minWidth: 116,
        },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        { title: '商品名称', key: 'goodsName', minWidth: 116 },
        { title: '产地', key: 'countryOfOrigin', minWidth: 116 },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 130,
          render: (h, { row, index }) => h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: (e) => {
                e.stopPropagation();
                if (this.currentSelectedId === row.id) {
                  this.currentSelectedId = null;
                  this.finalTableData = [];
                }
                this.tableData.splice(index, 1);
                this.$Message.success('删除成功');
              },
            },
          }, '删除'),
        },
      ],
      isImportArr: ['', '是', '否'],
      modalLoading: false,
      modalVisiable: false,
      modalQuery: {
        nameMix: null,
      },
      modalParams: {},
      modalPage: {
        page: 1,
        size: 10,
        count: 0,
      },
      tempSelection: [],
      modalTableData: [],
      modalColumns: [
        {
          title: '选择', key: 'id', type: 'selection', width: 60,
        },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '药品通用名', key: 'approvedDrugNames', minWidth: 156 },
        { title: '商品类型', key: 'typeString', minWidth: 156 },
        { title: '规格', key: 'specifications', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 186 },
        { title: '批准文号/注册证号', key: 'approvalNumber', minWidth: 166 },
        { title: '剂型', key: 'dosageFormString', minWidth: 116 },
        { title: '药品最小包装单位', key: 'drugMiniPackageUnitString', minWidth: 166 },
        { title: '储存条件', key: 'storageConditionsString', minWidth: 116 },
        { title: '本位码', key: 'ndcNumber', minWidth: 116 },
        { title: '产地', key: 'countryOfOrigin', minWidth: 116 },
        { title: '质检标准', key: 'drugAcceptanceStandard', minWidth: 116 },
        { title: '批件号', key: 'drugRegApprovalCode', minWidth: 166 },
        { title: '批件有效期', key: 'periodDrugRegApproval', minWidth: 166 },
        { title: '商品名称', key: 'goodsName', minWidth: 116 },
        { title: '化学成分', key: 'chemicalComposition', minWidth: 116 },
        { title: '条形码', key: 'barCode', minWidth: 116 },
        { title: '是否进口', key: 'isImport', minWidth: 116 },
        {
          title: '商品标签', key: 'goodsLabelsString', minWidth: 156, tooltip: true,
        },
        { title: '商品分类', key: 'indicationDicString', minWidth: 156 },
        {
          title: '状态',
          minWidth: 116,
          key: 'baseInfoStatus',
          render: (h, { row }) => h('span', row.goodsBaseStatus === 1 ? '启用' : '禁用'),
        },
      ],
    };
  },
  computed: {
    goodsTypes() {
      return this.$store.state.publicParams.purchaseGoodsTypes;
    },
    selectedIds() {
      const result = [];
      this.tableData.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
    tempSelectionIds() {
      const result = [];
      this.tempSelection.forEach((item) => {
        result.push(item.id);
      });
      return result;
    },
  },
  methods: {
    submit() {
      const params = {
        cleanse: {
          name: '合并基础商品',
          requirement: '',
        },
        cleanseGoodsBaseVoList: [],
      };

      const originalSerialCodeList = []; // 被合并的商品编码
      const changedGoodsBaseList = []; // 被合并的商品信息
      const newSerial = this.finalTableData[0]; // 合并至商品信息
      this.tableData.forEach((item) => {
        if (item.originGoodsBaseId !== newSerial.originGoodsBaseId) {
          originalSerialCodeList.push(item.drugSerialCode);
          changedGoodsBaseList.push({
            goodsBaseId: item.originGoodsBaseId,
            serialCode: item.drugSerialCode,
            approvedName: item.approvedDrugNames,
            goodsName: item.goodsName,
            dosageFormString: item.dosageFormString,
            approvalCode: item.approvalNumberType + item.approvalNumbere,
            spec: item.specifications,
            producer: item.manufacturer,
            origin: item.countryOfOrigin,
            goodsType: item.type,
          });
        }
      });

      params.cleanse.requirement = `基础商品${originalSerialCodeList.join('、')}合并到${newSerial.drugSerialCode}`;
      params.cleanseGoodsBaseVoList.push({
        changedGoodsBaseList,
        newSerialCode: newSerial.drugSerialCode,
      });
      this.submitLoading = true;
      this.$store.commit('setDisableLoading', true);
      toolsService.getMergeEqualSubmit(params).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success('提交成功');
          setTimeout(() => {
            this.handleToList();
          }, 1000);
        } else {
          this.$Message.error(res.data.error);
        }
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
      }).catch((err) => {
        this.submitConfirmVisiable = false;
        this.submitLoading = false;
        utils.handleError(err);
      });
    },
    submitConfirm() {
      if (this.tableData.length === 0) {
        this.$Message.error('请添加重复商品');
        return;
      }
      if (this.finalTableData.length === 0) {
        this.$Message.error('请选择要合并至的商品');
        return;
      }
      this.submitConfirmVisiable = true;
    },
    handleToList() {
      this.$router.push({
        name: 'mergeEqualGoodsList',
      });
    },
    handleSelectGoods() {
    },
    handleSelectClick(row) {
      this.finalTableData = [row];
      this.currentSelectedId = row.id;
    },
    getModalData() {
      this.modalParams.page = this.modalPage.page;
      this.modalParams.size = this.modalPage.size;
      this.$store.commit('setDisableLoading', true);
      this.modalLoading = true;
      goodsService.listGoodsBases(this.modalParams).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.modalTableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item.goodsBase, result);
            result.goodsBaseId = result.id;
            result.originGoodsBaseId = result.id;
            result.drugRegApprovalCode = item.goodsBase.drugRegApprovalCode || item.goodsBase.importRegCertCode;
            result.periodDrugRegApproval = utils.exchangeTime(item.goodsBase.periodDrugRegApproval || item.goodsBase.periodImportRegCert);
            result.drugMiniPackageUnitString = item.drugMiniPackageUnitString;
            result.storageConditionsString = item.storageConditionsString;
            result.dosageFormString = item.dosageFormString;
            result.goodsLabelsString = item.goodsLabelsString;
            result.isImport = this.isImportArr[item.goodsBase.isImport];
            if (item.indicationDicString) {
              const regExp = new RegExp(',', 'g');
              result.indicationDicString = item.indicationDicString.replace(regExp, '/');
            }
            result.typeString = utils.handleGoodsTypeStr(item.goodsBase.type);
            result._checked = this.selectedIds.includes(result.id) || this.tempSelectionIds.includes(result.id);
            result._disabled = this.selectedIds.includes(result.id);
            this.modalTableData.push(result);
          });
          this.modalPage.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
        this.modalLoading = false;
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    clearModalQuery() {
      this.modalQuery = {};
    },
    hideModal() {
      this.modalVisiable = false;
    },
    handleAdd() {
      this.modalVisiable = true;
      this.clearModalQuery();
      this.handleModalSearch();
    },
    handleModalSearch() {
      this.tempSelection = [];
      this.modalPage.page = 1;
      this.modalPage.size = 10;
      this.modalParams = utils.deepClone(this.modalQuery);
      this.getModalData();
    },
    pushModalData() {
      if (this.tempSelection.length === 0 && this.tableData.length === 0) {
        this.$Message.error('请选择记录');
        return;
      }

      if (this.tempSelection.length > 10) {
        this.$store.commit('setLoading', true);
        utils.timeChunk(this.tempSelection, (goods) => {
          this.tableData.push(goods);
        }, 10, () => {
          this.$store.commit('setLoading', false);
        })();
      } else {
        this.tempSelection.forEach((item) => {
          this.tableData.push(item);
        });
      }

      this.tempSelection = [];
      this.hideModal();
    },
    handleModalPage(val) {
      this.modalPage.page = val;
      this.getModalData();
    },
    handleModalSize(val) {
      this.modalPage.size = val;
      this.getModalData();
    },
    handleTempSelect(selection, row) {
      if (!this.tempSelectionIds.includes(row.id)) {
        this.tempSelection.push(row);
      }
    },
    handleTempCancel(selection, row) {
      this.tempSelection.forEach((item, index) => {
        if (item.id === row.id) {
          this.tempSelection.splice(index, 1);
        }
      });
    },
    handleSelectAll(selection) {
      selection.forEach((item) => {
        if (!this.tempSelectionIds.includes(item.id) && !this.selectedIds.includes(item.id)) {
          this.tempSelection.push(item);
        }
      });
    },
    handleSelectAllCancel() {
      this.modalTableData.forEach((good) => {
        for (let i = 0, len = this.tempSelection.length; i < len; i++) {
          if (this.tempSelection[i].id === good.id) {
            this.tempSelection.splice(i, 1);
            break;
          }
        }
      });
    },
  },
  created() {
    this.finalColumns = this.columns.slice(1, this.columns.length - 1);
  },
};
</script>
<style lang="less" scoped>
  .red {
    color: red;
  }
</style>
